import { render, staticRenderFns } from "./TripartiteData.vue?vue&type=template&id=236b9e8a&scoped=true"
import script from "./TripartiteData.vue?vue&type=script&lang=js"
export * from "./TripartiteData.vue?vue&type=script&lang=js"
import style0 from "./TripartiteData.vue?vue&type=style&index=0&id=236b9e8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b9e8a",
  null
  
)

export default component.exports